/* SheBliss Theme — Master JS (HARDENED for FB/IG webview)
   - Every fetch wrapped in try/catch + .catch
   - Feature-detection for browser APIs (Element.closest, fetch, FormData, IntersectionObserver)
   - Throws are isolated per-handler so one broken section never breaks the rest
   - No optional chaining, no arrow functions in critical paths (older IG webview compat)
   ============================================================ */
(function(){
  'use strict';

  /* ───────── Webview-safe polyfills ───────── */
  if (typeof Element !== 'undefined' && !Element.prototype.closest) {
    Element.prototype.closest = function(s){
      var el = this;
      while (el && el.nodeType === 1){
        if (el.matches && el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      }
      return null;
    };
  }
  if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  /* ───────── Safe wrappers ───────── */
  function safeOn(target, evt, handler){
    try {
      target.addEventListener(evt, function(e){
        try { handler(e); } catch(err){ if(window.console) console.warn('[SheBliss] handler '+evt+':', err); }
      }, false);
    } catch(err){ if(window.console) console.warn('[SheBliss] addEventListener failed:', err); }
  }
  function safeQ(sel, root){
    try { return (root || document).querySelector(sel); } catch(err){ return null; }
  }
  function safeQA(sel, root){
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch(err){ return []; }
  }
  function safeFetch(url, opts){
    if (typeof fetch !== 'function') return Promise.reject(new Error('fetch unsupported'));
    var defaults = { credentials:'same-origin', headers:{ 'Accept':'application/json' } };
    try {
      return fetch(url, Object.assign({}, defaults, opts || {})).then(function(r){
        if (!r.ok) throw new Error('HTTP '+r.status);
        return r.json();
      });
    } catch(err){ return Promise.reject(err); }
  }

  /* ───────── FAQ accordion (delegated, safe) ───────── */
  safeOn(document, 'click', function(e){
    var btn = e.target.closest && e.target.closest('.yb-faq-q');
    if (!btn) return;
    var item = btn.closest('.yb-faq-item');
    if (item) item.classList.toggle('open');
  });

  /* ───────── Before / After slider ───────── */
  window.ybBA = function(val, scope){
    try {
      var root = scope || document;
      var after = root.querySelector('.yb-ba-after');
      var line = root.querySelector('.yb-ba-line');
      var handle = root.querySelector('.yb-ba-handle');
      if (after) after.style.clipPath = 'inset(0 0 0 ' + val + '%)';
      if (line) line.style.left = val + '%';
      if (handle) handle.style.left = val + '%';
    } catch(err){}
  };

  /* ───────── PDP gallery thumb switcher (legacy) ───────── */
  window.ybThumb = function(el, idx){
    try {
      var box = el.closest('.yb-gallery');
      if (!box) return;
      var thumbs = box.querySelectorAll('.yb-gallery-thumb');
      for (var i=0; i<thumbs.length; i++) thumbs[i].classList.remove('active');
      el.classList.add('active');
      var main = box.querySelector('.yb-gallery-main img');
      var src = el.querySelector('img');
      if (main && src) main.src = src.dataset.full || src.src;
    } catch(err){}
  };

  /* ───────── Doctor video player ───────── */
  window.ybPlayDoc = function(wrap){
    try {
      var vid = wrap.querySelector('video');
      if (!vid) return;
      if (vid.paused){
        var playing = document.querySelectorAll('.yb-doc-vid-wrap.playing video');
        for (var i=0; i<playing.length; i++){
          try { playing[i].pause(); playing[i].closest('.yb-doc-vid-wrap').classList.remove('playing'); } catch(e){}
        }
        vid.muted = false;
        var p = vid.play();
        if (p && typeof p.then === 'function') p.then(function(){}).catch(function(){});
        wrap.classList.add('playing');
      } else {
        vid.pause();
        wrap.classList.remove('playing');
      }
    } catch(err){}
  };

  /* ───────── Mobile menu drawer (legacy) ───────── */
  safeOn(document, 'click', function(e){
    var open = e.target.closest && e.target.closest('[data-mob-menu-open]');
    var close = e.target.closest && e.target.closest('[data-mob-menu-close]');
    var menu = document.getElementById('yb-mob-menu');
    if (!menu) return;
    if (open){ menu.classList.add('open'); document.body.style.overflow='hidden'; }
    if (close){ menu.classList.remove('open'); document.body.style.overflow=''; }
  });

  /* ───────── Cart drawer ───────── */
  safeOn(document, 'click', function(e){
    var openTrig = e.target.closest && e.target.closest('[data-cart-open]');
    var closeTrig = e.target.closest && (e.target.closest('[data-cart-close]') || e.target.closest('.yb-cart-overlay'));
    var drawer = document.getElementById('yb-cart-drawer');
    var overlay = document.getElementById('yb-cart-overlay');
    if (!drawer) return;
    if (openTrig){ e.preventDefault(); drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); }
    if (closeTrig){ drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); document.body.style.overflow=''; }
  });

  function refreshCart(){
    safeFetch('/cart.js')
      .then(function(cart){ try { renderCart(cart); updateCount(cart); } catch(e){} })
      .catch(function(){});
  }

  function updateCount(cart){
    var els = safeQA('.yb-cart-count, [data-cart-count]');
    for (var i=0; i<els.length; i++){
      var el = els[i];
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    }
  }
  window.SheBlissRefreshCartCount = function(){ refreshCart(); };

  function fmt(money){
    try {
      var rupees = (money/100).toFixed(2);
      return '₹' + rupees.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } catch(e){ return '₹' + money; }
  }

  function renderCart(cart){
    var body = document.getElementById('yb-cart-body');
    var foot = document.getElementById('yb-cart-foot');
    updateCount(cart);
    if (!body) return;
    if (cart.item_count === 0){
      body.innerHTML = '<div class="yb-cart-empty">Your bag is empty.<br><br><a class="btn btn--secondary" href="/collections/all">Browse products</a></div>';
      if (foot) foot.style.display='none';
      return;
    }
    var html = '';
    for (var i=0; i<cart.items.length; i++){
      var it = cart.items[i];
      var title = (it.product_title || '').replace(/"/g,'&quot;').replace(/</g,'&lt;');
      var meta = ((it.variant_title || '') + ' · Qty ' + it.quantity).replace(/</g,'&lt;');
      html += '<div class="yb-cart-item">';
      html += '<img src="'+ (it.image||'') +'" alt="'+ title +'">';
      html += '<div>';
      html += '<div class="yb-cart-item-title">'+ title +'</div>';
      html += '<div class="yb-cart-item-meta">'+ meta +'</div>';
      html += '<a href="#" data-cart-remove="'+ it.key +'" style="font-size:11px;color:#888;text-decoration:underline">Remove</a>';
      html += '</div>';
      html += '<div class="yb-cart-item-price">'+ fmt(it.final_line_price) +'</div>';
      html += '</div>';
    }
    body.innerHTML = html;
    if (foot){
      foot.style.display='block';
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = fmt(cart.total_price);
    }
  }

  // Remove cart line
  safeOn(document, 'click', function(e){
    var rm = e.target.closest && e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    var key = rm.getAttribute('data-cart-remove');
    safeFetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id:key, quantity:0 })
    }).then(renderCart).catch(function(){});
  });

  /* ───────── Add to cart from PDP form ───────── */
  safeOn(document, 'submit', function(e){
    var form = e.target.closest && e.target.closest('form[data-pdp-form]');
    if (!form) return;
    e.preventDefault();
    var fd;
    try { fd = new FormData(form); } catch(err){ return; }
    safeFetch('/cart/add.js', { method:'POST', body: fd, headers:{ 'Accept':'application/json' } })
      .then(function(){
        var drawer = document.getElementById('yb-cart-drawer');
        var overlay = document.getElementById('yb-cart-overlay');
        if (drawer) drawer.classList.add('open');
        if (overlay) overlay.classList.add('open');
        document.body.style.overflow='hidden';
        refreshCart();
      })
      .catch(function(){ /* silent fail — user can retry */ });
  });

  /* ───────── Sticky mobile ATC visibility on scroll (legacy v1) ───────── */
  try {
    var sticky = safeQ('.yb-sticky-atc');
    var hero = safeQ('.yb-product');
    if (sticky && hero && window.innerWidth <= 749){
      var lastBottom = 0;
      window.addEventListener('scroll', function(){
        try {
          var rect = hero.getBoundingClientRect();
          if (rect.bottom < 0) sticky.classList.add('show'); else sticky.classList.remove('show');
        } catch(e){}
      }, { passive: true });
    }
  } catch(e){}

  /* ───────── Init cart count on page load ───────── */
  if (safeQ('.yb-cart-count') || safeQ('[data-cart-count]')) {
    refreshCart();
  }

  /* ───────── Predictive search (super lightweight) ───────── */
  var searchInput = safeQ('[data-search-input]');
  var searchResults = safeQ('[data-search-results]');
  if (searchInput && searchResults){
    var t;
    safeOn(searchInput, 'input', function(){
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (q.length < 2){ searchResults.innerHTML=''; return; }
      t = setTimeout(function(){
        safeFetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(data){
            var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (!prods.length){ searchResults.innerHTML='<div style="padding:14px;color:#888;font-size:13px">No matches.</div>'; return; }
            var h = '';
            for (var i=0; i<prods.length; i++){
              var p = prods[i];
              h += '<a href="'+ p.url +'" style="display:flex;gap:10px;padding:10px 12px;border-bottom:1px solid var(--color-border);align-items:center"><img src="'+(p.image||'')+'" style="width:42px;height:42px;border-radius:6px;object-fit:cover" alt=""><span style="font-size:13px;color:var(--color-dark);font-weight:700">'+ p.title +'</span></a>';
            }
            searchResults.innerHTML = h;
          })
          .catch(function(){});
      }, 200);
    });
  }

  /* ============================================================
     SB CART DRAWER — slide-out, AJAX-driven
     Triggered by [data-sbcd-open], closed by [data-sbcd-close]
     ============================================================ */
  var SBCart = {
    open: function(){
      var el = document.getElementById('sbcd');
      var ov = document.getElementById('sbcdOverlay');
      if(el) el.classList.add('is-open');
      if(ov) ov.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function(){
      var el = document.getElementById('sbcd');
      var ov = document.getElementById('sbcdOverlay');
      if(el) el.classList.remove('is-open');
      if(ov) ov.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    refresh: function(){
      try {
        fetch('/cart.js', { headers:{ 'Accept':'application/json' }})
          .then(function(r){ return r.json(); })
          .then(function(cart){
            SBCart.render(cart);
            SBCart.updateCount(cart.item_count);
            SBCart.filterUpsells(cart);
          })
          .catch(function(){});
      } catch(e){}
    },
    filterUpsells: function(cart){
      var list = document.getElementById('sbcdUpsellList');
      if(!list) return;
      var inCartProds = {};
      var inCartVars = {};
      for(var i = 0; i < cart.items.length; i++){
        inCartProds[cart.items[i].product_id] = true;
        inCartVars[cart.items[i].variant_id] = true;
        inCartVars[cart.items[i].id] = true;
      }
      var items = list.querySelectorAll('.sbcd-up');
      var visibleCount = 0;
      items.forEach(function(it){
        var v = it.getAttribute('data-variant');
        if(v && inCartVars[v]){
          it.style.display = 'none';
        } else {
          it.style.display = '';
          visibleCount++;
        }
      });
      var upsell = document.getElementById('sbcdUpsell');
      if(upsell){
        upsell.style.display = (visibleCount === 0) ? 'none' : '';
      }
    },
    updateCount: function(n){
      var els = document.querySelectorAll('.yb-cart-count');
      els.forEach(function(el){
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
      var count2 = document.getElementById('sbcdCount');
      if(count2) count2.textContent = n;
    },
    formatMoney: function(cents){
      var rs = (cents / 100).toFixed(2);
      return 'Rs. ' + rs.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    render: function(cart){
      var body = document.getElementById('sbcdBody');
      var foot = document.getElementById('sbcdFoot');
      var subT = document.getElementById('sbcdSubtotal');
      if(!body) return;
      if(cart.item_count === 0){
        body.innerHTML = '<div class="sbcd-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="56" height="56"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><h3>Your cart is empty</h3><p>Add SheBliss to your daily ritual.</p><a href="/" class="sbcd-shop-btn" data-sbcd-close>Continue Shopping</a></div>';
        if(foot) foot.style.display = 'none';
        return;
      }
      if(foot) foot.style.display = '';
      var h = '<div class="sbcd-items" id="sbcdItems">';
      for(var i = 0; i < cart.items.length; i++){
        var it = cart.items[i];
        var img = it.image ? it.image.replace('.jpg', '_200x.jpg').replace('.png','_200x.png') : '';
        var variantTxt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="sbcd-item-var">'+it.variant_title+'</span>' : '';
        h += '<div class="sbcd-item" data-key="'+it.key+'" data-line="'+(i+1)+'">'
          +    '<a href="'+it.url+'" class="sbcd-item-img" data-sbcd-close><img src="'+img+'" alt="" loading="lazy"></a>'
          +    '<div class="sbcd-item-info">'
          +      '<a href="'+it.url+'" class="sbcd-item-name" data-sbcd-close>'+it.product_title+'</a>'
          +      variantTxt
          +      '<div class="sbcd-item-row">'
          +        '<div class="sbcd-qty">'
          +          '<button type="button" class="sbcd-qty-btn" data-sbcd-qty="dec">−</button>'
          +          '<input type="number" class="sbcd-qty-input" value="'+it.quantity+'" min="0" data-line="'+(i+1)+'">'
          +          '<button type="button" class="sbcd-qty-btn" data-sbcd-qty="inc">+</button>'
          +        '</div>'
          +        '<div class="sbcd-item-price">'+SBCart.formatMoney(it.final_line_price)+'</div>'
          +      '</div>'
          +      '<button type="button" class="sbcd-item-rm" data-sbcd-remove>Remove</button>'
          +    '</div>'
          +  '</div>';
      }
      h += '</div>';
      body.innerHTML = h;
      if(subT) subT.textContent = SBCart.formatMoney(cart.total_price);
    },
    changeLine: function(line, qty){
      try {
        fetch('/cart/change.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            SBCart.render(cart);
            SBCart.updateCount(cart.item_count);
          })
          .catch(function(){});
      } catch(e){}
    }
  };
  window.SBCart = SBCart;

  /* Upsell add-to-cart */
  safeOn(document, 'click', function(e){
    var btn = e.target.closest && e.target.closest('[data-sbcd-upsell-add]');
    if(!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant');
    if(!variantId) return;
    var origHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-3-6.7"/></svg>';
    try {
      fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r){ return r.json(); })
        .then(function(){
          btn.classList.add('is-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
          SBCart.refresh();
          setTimeout(function(){ btn.disabled = false; btn.innerHTML = origHtml; btn.classList.remove('is-added'); }, 1500);
        })
        .catch(function(){ btn.disabled = false; btn.innerHTML = origHtml; });
    } catch(err){ btn.disabled = false; btn.innerHTML = origHtml; }
  });

  /* Initial filter on page load (skip items already in cart) */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ SBCart.refresh(); });
  } else {
    setTimeout(function(){ SBCart.refresh(); }, 100);
  }

  /* Cart drawer open triggers */
  safeOn(document, 'click', function(e){
    var t = e.target.closest && e.target.closest('[data-sbcd-open]');
    if(t){
      e.preventDefault();
      SBCart.refresh();
      SBCart.open();
    }
  });
  /* Cart drawer close triggers */
  safeOn(document, 'click', function(e){
    if(e.target.closest && e.target.closest('[data-sbcd-close]')){
      SBCart.close();
    }
  });
  /* Qty +/- and Remove */
  safeOn(document, 'click', function(e){
    var qtyBtn = e.target.closest && e.target.closest('[data-sbcd-qty]');
    if(qtyBtn){
      var item = qtyBtn.closest('.sbcd-item');
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('.sbcd-qty-input');
      var current = parseInt(input.value, 10) || 0;
      var newQty = qtyBtn.getAttribute('data-sbcd-qty') === 'inc' ? current + 1 : Math.max(0, current - 1);
      SBCart.changeLine(line, newQty);
      return;
    }
    var rm = e.target.closest && e.target.closest('[data-sbcd-remove]');
    if(rm){
      var it = rm.closest('.sbcd-item');
      var ln = parseInt(it.getAttribute('data-line'), 10);
      SBCart.changeLine(ln, 0);
      return;
    }
  });
  /* Qty input direct edit */
  safeOn(document, 'change', function(e){
    if(e.target.matches && e.target.matches('.sbcd-qty-input')){
      var line = parseInt(e.target.getAttribute('data-line'), 10);
      var qty = parseInt(e.target.value, 10) || 0;
      SBCart.changeLine(line, qty);
    }
  });
  /* Escape closes drawer */
  safeOn(document, 'keydown', function(e){ if(e.key === 'Escape') SBCart.close(); });

  /* ============================================================
     SB SEARCH OVERLAY — predictive search via /search/suggest.json
     ============================================================ */
  var SBSearch = {
    debounceTimer: null,
    open: function(){
      var el = document.getElementById('sbso');
      var ov = document.getElementById('sbsoOverlay');
      if(el) el.classList.add('is-open');
      if(ov) ov.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function(){
        var input = document.getElementById('sbsoInput');
        if(input) input.focus();
      }, 250);
    },
    close: function(){
      var el = document.getElementById('sbso');
      var ov = document.getElementById('sbsoOverlay');
      if(el) el.classList.remove('is-open');
      if(ov) ov.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    formatMoney: function(cents){
      var rs = (cents / 100).toFixed(2);
      return 'Rs. ' + rs.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    search: function(query){
      var results = document.getElementById('sbsoResults');
      if(!query || query.length < 2){
        results.innerHTML = '<div class="sbso-popular"><h4 class="sbso-section-title">Popular Searches</h4><div class="sbso-tags">'
          + '<button type="button" class="sbso-tag" data-sbso-query="V-Tightening Serum">V-Tightening</button>'
          + '<button type="button" class="sbso-tag" data-sbso-query="B-Enhancing Serum">B-Enhancing</button>'
          + '<button type="button" class="sbso-tag" data-sbso-query="B-Tightening Serum">B-Tightening</button>'
          + '<button type="button" class="sbso-tag" data-sbso-query="ingredients">Ingredients</button>'
          + '<button type="button" class="sbso-tag" data-sbso-query="how to use">How to use</button>'
          + '<button type="button" class="sbso-tag" data-sbso-query="refund policy">Refund Policy</button>'
          + '</div></div>';
        return;
      }
      results.innerHTML = '<div class="sbso-loading"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-3-6.7"/></svg></div>';
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=8&resources[options][prefix]=last';
      try {
        fetch(url, { headers:{ 'Accept':'application/json' }})
          .then(function(r){ return r.json(); })
          .then(function(data){
            SBSearch.render(data, query);
          })
          .catch(function(){
            results.innerHTML = '<div class="sbso-no"><strong>Search unavailable</strong>Try again in a moment.</div>';
          });
      } catch(e){
        results.innerHTML = '<div class="sbso-no"><strong>Search unavailable</strong>Try again in a moment.</div>';
      }
    },
    render: function(data, q){
      var results = document.getElementById('sbsoResults');
      var d = (data && data.resources && data.resources.results) ? data.resources.results : {};
      var prods = d.products || [];
      var pages = d.pages || [];
      var arts = d.articles || [];
      if(prods.length === 0 && pages.length === 0 && arts.length === 0){
        results.innerHTML = '<div class="sbso-no"><strong>No results for "'+q+'"</strong>Try a different search term.</div>';
        return;
      }
      var h = '';
      if(prods.length > 0){
        h += '<div class="sbso-grp"><h4 class="sbso-grp-title">Products</h4><div class="sbso-prod-list">';
        for(var i = 0; i < prods.length; i++){
          var p = prods[i];
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var was = (p.compare_at_price_min && p.compare_at_price_min > p.price_min) ? '<s class="sbso-prod-was">'+SBSearch.formatMoney(p.compare_at_price_min)+'</s>' : '';
          h += '<a href="'+p.url+'" class="sbso-prod" data-sbso-close>'
            + '<div class="sbso-prod-img"><img src="'+img+'" alt="" loading="lazy"></div>'
            + '<div class="sbso-prod-info"><div class="sbso-prod-name">'+p.title+'</div><div class="sbso-prod-price">'+SBSearch.formatMoney(p.price_min || p.price)+was+'</div></div>'
            + '</a>';
        }
        h += '</div><a href="/search?q='+encodeURIComponent(q)+'" class="sbso-view-all" data-sbso-close>View all results →</a></div>';
      }
      if(pages.length > 0){
        h += '<div class="sbso-grp"><h4 class="sbso-grp-title">Pages</h4><div class="sbso-page-list">';
        for(var j = 0; j < pages.length; j++){
          h += '<a href="'+pages[j].url+'" class="sbso-page" data-sbso-close>'+pages[j].title+'</a>';
        }
        h += '</div></div>';
      }
      if(arts.length > 0){
        h += '<div class="sbso-grp"><h4 class="sbso-grp-title">Articles</h4><div class="sbso-page-list">';
        for(var k = 0; k < arts.length; k++){
          h += '<a href="'+arts[k].url+'" class="sbso-page" data-sbso-close>'+arts[k].title+'</a>';
        }
        h += '</div></div>';
      }
      results.innerHTML = h;
    }
  };
  window.SBSearch = SBSearch;

  /* Search open trigger */
  safeOn(document, 'click', function(e){
    var t = e.target.closest && e.target.closest('[data-sbso-open]');
    if(t){ e.preventDefault(); SBSearch.open(); }
  });
  /* Search close trigger */
  safeOn(document, 'click', function(e){
    if(e.target.closest && e.target.closest('[data-sbso-close]')){ SBSearch.close(); }
  });
  /* Predictive search on input */
  safeOn(document, 'input', function(e){
    if(e.target.id === 'sbsoInput'){
      var q = e.target.value.trim();
      clearTimeout(SBSearch.debounceTimer);
      SBSearch.debounceTimer = setTimeout(function(){ SBSearch.search(q); }, 220);
    }
  });
  /* Popular tag click — fill input + search */
  safeOn(document, 'click', function(e){
    var tag = e.target.closest && e.target.closest('[data-sbso-query]');
    if(tag){
      var q = tag.getAttribute('data-sbso-query');
      var input = document.getElementById('sbsoInput');
      if(input){ input.value = q; input.focus(); }
      SBSearch.search(q);
    }
  });
  /* Escape closes search */
  safeOn(document, 'keydown', function(e){ if(e.key === 'Escape') SBSearch.close(); });

  /* ───────── Global error catcher (last line of defense) ───────── */
  window.addEventListener('error', function(e){
    if (window.console) console.warn('[SheBliss caught]', e && e.message);
  });
  window.addEventListener('unhandledrejection', function(e){
    if (window.console) console.warn('[SheBliss rejection caught]', e && e.reason);
    if (e && e.preventDefault) e.preventDefault();
  });

})();
